export const getMenueByName=(list, obj)=>{
  return munueCome(list, obj);
}
const munueCome = (list, obj) => {
  for (let o of list) {
    if (o.name == obj.name) {
      return o;
    }
    if (o.children) {
      munueCome(o.children,obj);
    }
  }
};
